import React from 'react'
import { SettingsRow } from "pages/NewSettings/settings-row";
import useTranslation from 'hooks/useTranslation';
import { Fields } from 'uicomponents';
import { Field } from 'formik';


const TaxParameters = () => {
  const { tr } = useTranslation();
  return (
    <div>
      <SettingsRow
        title={tr("ИНН")}
        description={tr("Введите ИНН")}
      >
        <Field
          component={Fields.InputS1}
          name="tax"
          placeholder={tr("Введите")}
          isRequired={true}
          size={"small"}
        />
      </SettingsRow>
      <SettingsRow
        title={tr("Номер виртуальной кассы")}
        description={tr("Введите номер")}
      >
        <Field
          component={Fields.InputS1}
          name="virtual_cash_register_number"
          placeholder={tr("Введите")}
          isRequired={true}
          size={"small"}
        />
      </SettingsRow>
      <SettingsRow
        title={tr("IP адресс виртуальной кассы")}
        description={tr("Введите номер")}
      >
        <Field
          component={Fields.InputS1}
          name="virtual_cash_register_ip_address"
          placeholder={tr("Введите")}
          isRequired={true}
          size={"small"}
        />
      </SettingsRow>
      {/* <SettingsRow
        title={tr("Идентификационные коды продукции и услуг")}
      >
        <Field
          component={Fields.InputS1}
          name="tax_fields_spic"
          type="text"
          size={"small"}
          placeholder={tr("Введите ИКПУ")}
        />
      </SettingsRow>
      <SettingsRow
        title={tr("Код упаковки")}
      >
        <Field
          component={Fields.InputS1}
          name="tax_fields_packageCode"
          type="text"
          size={"small"}
          placeholder={tr("Введите код упаковки")}
        />
      </SettingsRow>
      <SettingsRow
        title={tr("Тип владельца")}
      >
        <Field
          name="tax_fields_ownerType"
          type="text"
          component={Fields.SelectS1}
          optionLabel="name"
          optionValue="id"
          placeholder={tr("Выберите тип")}
          size={"small"}
          options={[
            { name: tr("Sotib olib sotayotgan"), id: "1", value: 1, },
            { name: tr("O'zi ishlab chiqargan"), id: "2", value: 2, },
            { name: tr("Xizmat ko'rsatuvchi"), id: "3", value: 3, },
          ]}
        />
      </SettingsRow>
      <SettingsRow
        title={tr("НДС")}
      >
        <Field
          component={Fields.InputS1}
          name="tax_fields_vatPercent"
          type="text"
          size={"small"}
          placeholder={tr("Введите НДС")}
        />
      </SettingsRow>
      <SettingsRow
        title={tr("Единица измерения")}
      >
        <Field
          name="tax_fields_units"
          type="text"
          component={Fields.SelectS1}
          optionLabel="name"
          optionValue="id"
          placeholder={tr("Выберите ед изм")}
          size={"small"}
          options={[
            { name: tr("кг"), id: "1", value: 1, },
            { name: tr("шт"), id: "2", value: 2, }
          ]}
        />
      </SettingsRow> */}
    </div >
  )
}

export default TaxParameters